Directives.WorkflowStepDirectiveController = function WorkflowStepDirectiveController() {

    // @ngInject
    function WorkflowStepDirectiveControllerFunc($scope, $injector) {
        this.constructor.$super.call(this, $scope, $injector);
        this.__objectType = 'WorkflowStepDirectiveController';
    }

    var WorkflowStepDirectiveController = Class(Controllers.BaseController, {
        constructor: WorkflowStepDirectiveControllerFunc,
    });

    return {
        scope: {
            show: '=show',
            bem:'@?'
        },
        transclude: {
            'step': '?stepIndex',
            'header': '?workflowStepHeader',
            'content': '?workflowStepContent',
            'read': '?readOnly'
        },
        templateUrl: 'angular/app/modules/core/features/workflows/workflow_setup/workflow_step_container_template.html',
        controller: WorkflowStepDirectiveController,
        controllerAs: 'workflowStepVm',
        bindToController: true
    };
};


